import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { Shortcut } from "components/WarehouseElements/WarehouseHeaders/WarehouseSearchZone/Shortcuts/Shortcuts";
import { INVALID_INDEX } from "constants/globals";
import { LEGEND_MODE } from "constants/navigation";
import { WarehouseInfos } from "models/PlanInfos";

const initialState = {
  warehousePlan: new WarehouseInfos(),
  storeNb: INVALID_INDEX,
  shortcuts: [] as Shortcut[],
  isGridRendered: false,
  legendDisplayType: LEGEND_MODE.REDUCED,
};

export const warehousePlanSlice = createSlice({
  name: "warehousePlanSlice",
  initialState,
  reducers: {
    setStoreNb(state, action: PayloadAction<number>) {
      state.storeNb = action.payload;
    },
    setWarehousePlan(state, action: PayloadAction<WarehouseInfos>) {
      state.warehousePlan = action.payload;
    },
    setIsGridRendered(state, action: PayloadAction<boolean>) {
      state.isGridRendered = action.payload;
    },
    setLegendDisplay(state, action: PayloadAction<LEGEND_MODE>) {
      state.legendDisplayType = action.payload;
    },
    resetWarehousePlan: state => {
      state.warehousePlan = initialState.warehousePlan;
    },
  },
});

export const {
  setStoreNb,
  setWarehousePlan,
  resetWarehousePlan,
  setIsGridRendered,
  setLegendDisplay,
} = warehousePlanSlice.actions;
export default warehousePlanSlice.reducer;
